export default __webpack_public_path__ + "3fda164aa50710f5536e6c098732865f.png";